export enum SalvageRequestorType {
    Owner = 1,
    SupervisoryAuthority = 2,
}

export enum EngineType {
    WithoutEngine = 1,
    WithEngine = 2,
}

export enum Documentations {
    // BuildingCertificate = 1,
    // MechanicalDrawing = 2,
    Catalogues = 3,
}
